export default __webpack_public_path__ + "static/media/Menu.3498691a.png";